import { toPng } from 'html-to-image';

import openInsightModal from 'components/partials/insight-modal/insight-modal';

import { setPendingInsightImage } from 'components/partials/insight-modal/insight-context';

export interface InsightScreenshotMetadata {
  isReport?: boolean;
  reportName?: string;
  title?: string;
  source?: string;
  name?: string;
  [key: string]: unknown;
}

export const captureInsightScreenshot = async (
  element: HTMLElement | null | undefined,
  metadata: InsightScreenshotMetadata = {}
): Promise<void> => {
  if (!element) return;

  try {
    const imgData = await toPng(element, {
      cacheBust: true,
      pixelRatio: window.devicePixelRatio || 2,
      skipFonts: true,
      filter: (node: HTMLElement) =>
        !(node.classList && node.classList.contains('add-insight-btn')),
    });

    let blob: Blob | null = null;

    try {
      const res = await fetch(imgData);

      blob = await res.blob();
    } catch (err) {
      console.warn('Failed to convert data URL to Blob:', err);
    }

    setPendingInsightImage({ blob, url: imgData });

    const withDefaults: InsightScreenshotMetadata = {
      source: metadata?.isReport ? 'report' : 'monitoring',
      name: metadata?.isReport
        ? metadata?.reportName || metadata?.title || 'Report'
        : 'Monitoring',
      ...metadata,
    };

    openInsightModal({ metadata: withDefaults });
  } catch (e) {
    console.error('Failed to create screenshot', e);
  }
};
